import React from 'react';

import { FormField, withFormField } from '@gogame/form';

const AgreementUri = ({ name, error, remove }) => {
  const handelUriChange = (_e, v) => {
    if (!v) {
      remove(0);
    }
  };
  return (
    <FormField.TextField
      label={'Agreement URL'}
      placeholder={'https://example.com'}
      name={`${name}.uri`}
      onChange={handelUriChange}
      error={error}
      padding={0}
    />
  );
};
const AgreementUriField = withFormField()(AgreementUri);

export default AgreementUriField;
